import React, { createContext, useContext, useEffect, useState } from "react";
import apiAdm from "../services/apiAdm";
import { clearAdminToken, setAdminToken } from "../services/authStorage";
import { normalizeAdmin } from "../services/apiUtils";

const AdminAuthContext = createContext();

export function AdminAuthProvider({ children }) {
    const [adm, setAdm] = useState(null);
    const [loading, setLoading] = useState(true);

    const logoutAdm = () => {
        clearAdminToken();
        setAdm(null);
    };

    useEffect(() => {
        const id = apiAdm.interceptors.response.use(
            (res) => res,
            (err) => {
                if (err?.response?.status === 401) {
                    setAdm((prev) => {
                        if (prev) logoutAdm();
                        return null;
                    });
                }
                return Promise.reject(err);
            }
        );

        return () => apiAdm.interceptors.response.eject(id);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        (async () => {
            try {
                const { data } = await apiAdm.get("/admin");
                setAdm(normalizeAdmin(data) || null);
            } catch (_) {
                clearAdminToken();
                setAdm(null);
            } finally {
                setLoading(false);
            }
        })();
    }, []);

    function loginAdm(adminData, token) {
        if (token) setAdminToken(token);
        setAdm(normalizeAdmin(adminData));
    }

    const isMaster = adm?.role === 1 || adm?.role === "MASTER";

    return (
        <AdminAuthContext.Provider value={{ adm, isMaster, loginAdm, logoutAdm, loading }}>
            {children}
        </AdminAuthContext.Provider>
    );
}

export function useAdminAuth() {
    return useContext(AdminAuthContext);
}
